module.exports = __webpack_public_path__ + "img/icon-mi-perfil.627ac6a9.svg";